
import React from 'react';
import { Form, Field} from 'react-final-form';
import Modal from '../../widgets/Modal';
import Confirm from '../../widgets/Confirm';
import {connect} from 'react-redux';
import {CardLarge} from '../../widgets/Cards';
import { fetchAODSubstances, fetchAODSubstance, editAODSubstance, newAODSubstance, deleteAODSubstance} from '../../../actions';

class AODSubstance extends React.Component {

    constructor(props) {
            super(props);
            this.state = {
                showModal: false,
                showDelete : false,
                newForm : true,
                record : null,
            };
        };


    //Initial Rendering
    componentDidMount() {
        this.props.fetchAODSubstances(this.props.patient._id)
    }

    componentDidUpdate(prevProps) {
        if (this.props.patient._id !== prevProps.patient._id) {
             this.props.fetchAODSubstances(this.props.patient._id)
        }
       
    }
    
    // Render content

    renderAODSubstanceList() {

        return this.props.aod_substances.map(aod_substance =>  {

            const rowButton = () => {
                var permit = this.props.selectedPermission.permission[0].substance;
                if (permit === "View only") {
                    return null;
                } else { 
                    return (
                        <>
                        <button onClick={() => this.setState({showModal: true, newForm: false, record: aod_substance._id})} className='tableEdit'><i className="far fa-edit"></i></button>
                        <button onClick={() => this.setState({showDelete: true, record: aod_substance._id})} className='tableDelete'><i className="fas fa-trash"></i></button>
                        </>
                    )
                }  
            }
//SECTION A    
            return (
                    <tr key={aod_substance._id}>
                        <td>{aod_substance.substance}</td>
                        <td>{aod_substance.firstage}</td>
                        <td>{aod_substance.agereguse}</td>
                        <td>{aod_substance.route}</td>
                        <td>{aod_substance.dailyav}</td>
                        <td>{aod_substance.daypastweek}</td>
                        <td>{aod_substance.dayfourweek}</td>
                        <td>{aod_substance.dayinject}</td>
                        <td>{aod_substance.lastuse}</td>
                        <td>{aod_substance.helpseek}</td>
                        <td>
                            {rowButton()}
                        </td>
                    </tr>
            )
        })
    }

    buttons() {
        var permit = this.props.selectedPermission.permission[0].substance;
        if (permit === "View only") {
            return null
        } else { 
            return  <button onClick={() => this.setState({showModal: true, newForm: true, record: null})} className='btnew'>Add</button>
        }  
    }

    render() {
        return (

//SECTION B
                <CardLarge title='Substance Use History' buttons={this.buttons()}>
                    <table>
                        <thead>
                        <tr>
                            <th>Substance</th>
                            <th>Age of first use</th>
                            <th>Age of regular use</th>
                            <th>Route</th>
                            <th>Daily Average use</th>
                            <th>Days use in 1 week</th>
                            <th>Days use in 4 weeks</th>
                            <th>Days of injection</th>
                            <th>Last Use</th>
                            <th>Help seek</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody> 
                            {this.renderAODSubstanceList()}
                        </tbody> 
                    </table>
                    {this.renderModalBox()}
                    {this.renderDeleteBox()}
           
                </CardLarge>
        )
    }

    //Update or New Form Pop Up

    renderModalBox() {
        const record = this.state.record;
        if (record !== null) {
           this.props.fetchAODSubstance(record);
        }

        const aod_substanceForm = () => {
            const required = value =>(value ? undefined : 'Required');
         
            var content;
            if (this.state.newForm === false ) {
                content = this.props.selectedVaccine;
            } else {
                content = null;
            }
            const currentVax = content;

            const handleSubmit = (formValues) => {
            
                const form = formValues;
                form['patientId'] = this.props.patient._id;
                form['userId'] = this.props.userId;  

                const aod_substanceId = form._id;
                if (aod_substanceId === undefined) {
                    this.props.newAODSubstance(form);
                } else {
                    this.props.editAODSubstance(form, aod_substanceId);
                }
                this.setState({showModal :false, newForm : true,record : null,});
           }

// SECTION C
            return (
                <Form 
                    onSubmit = {handleSubmit} 
                    initialValues = {currentVax}
                    render = {({ handleSubmit, pristine, form, values, submitting }) => {
                    return   (
                            <form onSubmit={handleSubmit}>

                                <Field name="substance" component='input' validate={required} placeholder='Substance'>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Substance</label>
                                            <input {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )}
                                </Field>
                                <Field name="firstage" component='input' validate={required} placeholder='Age when first use this substance'>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Age of first use</label>
                                            <input {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )}
                                </Field>
                                <Field name="agereguse" component='input' validate={required} placeholder='age range when use the substance regularly'>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Age of Regular use</label>
                                            <input {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )}
                                </Field>
                                <Field name="route" component='input' validate={required} placeholder='Route'>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Route</label>
                                            <input {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )}
                                </Field>
                                <Field name="dailyav" component='input' validate={required} placeholder='Average of daily use'>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Daily Average</label>
                                            <input {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )}
                                </Field>
                                <Field name="daypastweek" component='input' validate={required} placeholder='Number of days use in a week'>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Days of use past week</label>
                                            <input {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )}
                                </Field>
                                <Field name="dayfourweek" component='input' validate={required} placeholder='Number of days use in 4 weeks'>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Days of use in 4 weeks</label>
                                            <input {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )}
                                </Field>
                                <Field name="dayinject" component='input' validate={required} placeholder='Number of days use injection'>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Days of injecting</label>
                                            <input {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )}
                                </Field>
                                <Field name="lastuse" component='input' validate={required} placeholder='Last day of substance use'>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Day of Last Use</label>
                                            <input {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )}
                                </Field>
                                <Field name="helpseek" component='input' validate={required} placeholder='Help seek'>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Help seek</label>
                                            <input {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )}
                                </Field>
                                    <div className='modalButton'>
                                        <button type='submit' disabled={submitting || pristine} className='btnew'>Submit</button>
                                        <button type='button' onClick={form.reset} disabled={submitting || pristine } className='btdel'>Reset</button>
                                        <button onClick={() => this.setState({showModal: false, record: null})} className='btdel'>Cancel</button>
                                    </div>
                                  
                            </form>
                        )
                    }}
                />
            )
        }   
        //  <pre>{JSON.stringify(values, 0, 2)}</pre>

// main render

// SECTION D
        return (
            <Modal 
                height='300px'
                width='300px'
                open={this.state.showModal} 
                title='Substance Use History'
                data={this.state.record}
                content={aod_substanceForm()}
                onDismiss={() => this.setState({showModal: false, record: null})}
            />
        )
    }

    //Delete confirmation pop up
    renderDeleteBox() {

        const handleDelete = () => {
            this.props.deleteAODSubstance(this.state.record);
            this.setState({showDelete:false, record:null})
        }

        const deleteButtons = () => {
            return (
            <div>
                <button onClick={() => this.setState({showDelete: false})} className='btdel'>Cancel</button>
                <button onClick={handleDelete} className='btsave'>Ok</button>
            </div>
            )
        }

//SECTION E
        return (
            <Confirm
            height='100px'
            width='300px'
            open={this.state.showDelete} 
            data={this.state.record}
            content="Delete this Substance Use History ?"
            title='Delete Substance Use History'
            actions = {deleteButtons()}
            onDismiss={() => this.setState({showDelete : false, record:null})}
        />
        )

    }

}


const mapStateToProps = (state) => {
    return { 
        contents : state.selectedPatient,
        aod_substances : Object.values(state.aod_substances),
        patient : state.selectedPatient,
        userId : state.auth.userId,
        selectedPermission : state.selectedPermission,
    }
}

export default connect(mapStateToProps, {fetchAODSubstances, fetchAODSubstance, editAODSubstance, newAODSubstance, deleteAODSubstance})(AODSubstance);



